<template>
  <div class="main">
    <el-tabs v-model="activeName">
      <el-tab-pane :label="`岗位投递(${resumesNum.num1})`" name="0">
        <InternshipJob />
      </el-tab-pane>
      <el-tab-pane :label="`发现页岗位投递(${resumesNum.num4})`" name="4">
        <FindJob />
      </el-tab-pane>
      <el-tab-pane :label="`推荐岗位投递(${resumesNum.num2})`" name="1">
        <SignJob />
      </el-tab-pane>
      <el-tab-pane :label="`学校代企业发布岗位投递(${resumesNum.num3})`" name="2">
        <SchoolJob />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import InternshipJob from './components/internship-job'
import SignJob from './components/sign-job'
import SchoolJob from './components/school-job'
import FindJob from './components/find-job'

export default {
  components: {
    InternshipJob,
    SignJob,
    SchoolJob,
    FindJob,
  },
  data() {
    return {
      activeName: '0',
      resumesNum: {
        num1: '',
        num2: '',
        num3: '',
        num4: '',
      },
    }
  },
  mounted() {
    this.getResumesNum()
  },
  methods: {
    async getResumesNum() {
      // let p1 = await this.$api.studentManage.getStuByCom()
      // let p2 = await this.$api.job.resumesFromSignJob()
      let p = await this.$api.studentManage.getResumesNum()
      let p3 = await this.$api.studentManage.getStudentApplyList()
      // let p4 = await this.$api.job.resumesFromFind()
      let num1 = p.data.job
      let num2 = p.data.sign
      let num3 = p3.data.count
      let num4 = p.data.faxian
      this.resumesNum = {
        num1,
        num2,
        num3,
        num4,
      }
    },
  },
};
</script>

<style lang="scss" scope>
  .main {
    position: relative;
    padding: 20px;
  }
</style>